import { render, staticRenderFns } from "./knowledgePreview.vue?vue&type=template&id=e486834a&scoped=true"
import script from "./knowledgePreview.vue?vue&type=script&lang=js"
export * from "./knowledgePreview.vue?vue&type=script&lang=js"
import style0 from "./knowledgePreview.vue?vue&type=style&index=0&id=e486834a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e486834a",
  null
  
)

export default component.exports